import React, { useEffect, useState, useCallback, useRef } from 'react'
import { ContentType } from '../../../../../server/models/GenericContentFields'
import {
  ThreeSentenceSummaryCard,
  BlogOutlineContentCard,
  VideoScriptContentCard,
  CarouselSlidesContentCard,
  LoadingContentCard
} from '../../ContentCard'
import { useSourceContent } from '../../contexts/useSourceContent'

export const ListContentForSource: React.FC = () => {
  const { source, content, setEnabled, selectedContentTypes } = useSourceContent()
  const [isInView, setIsInView] = useState(false)

  const contentContainerRef = useRef<HTMLDivElement>(null)

  const isContentTypeSelected = useCallback((type: ContentType) => {
    return selectedContentTypes.includes(type)
  }, [selectedContentTypes])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true)
          }
        })
      },
      {
        root: null, // Use the viewport
        threshold: 0.1, // Trigger when 10% of the element is in view
      }
    )

    if (contentContainerRef.current) {
      observer.observe(contentContainerRef.current)
    }

    return () => {
      if (contentContainerRef.current) {
        observer.unobserve(contentContainerRef.current)
      }
    }
  }, [contentContainerRef])

  useEffect(() => {
    // Enable the query when the component comes into view
    setEnabled(isInView)
  }, [isInView, setEnabled])

  if (!content) {
    return (
      <div className="content-cards-container" ref={contentContainerRef}>
        <LoadingContentCard />
        <LoadingContentCard />
        <LoadingContentCard />
        <LoadingContentCard />
        <LoadingContentCard />
        <LoadingContentCard />
      </div>
    )
  }

  if (
    !source.contentGenerated ||
    (
      !content.threeSentenceSummary &&
      content.blogs.length === 0 &&
      content.shortVideoScript.length === 0 &&
      content.carousels.length === 0
    )
  ) {
    return null
  }

  return (
    <div className="content-cards-container">
      { isContentTypeSelected('summary') && (
        <ThreeSentenceSummaryCard
          threeSentenceSummary={content.threeSentenceSummary}
        />
      )}

      {isContentTypeSelected('blog') && content.blogs.map((blog) => (
        <BlogOutlineContentCard
          key={blog._id}
          blog={blog}
        />
      ))}

      { isContentTypeSelected('shortVideo') && content.shortVideoScript.map((script) => (
        <VideoScriptContentCard
          key={script._id}
          shortVideoScript={script}
        />
      ))}

      { isContentTypeSelected('carousel') && content.carousels.map((carousel) => (
        <CarouselSlidesContentCard
          key={carousel._id}
          slides={carousel}
        />
      ))}
    </div>
  )
}

